import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
const BASE_URL = process.env.REACT_APP_BASE_URL;

// All Coupons
export const fetchCoupons = createAsyncThunk("coupons/fetchCoupons", async (params = {}, { rejectWithValue }) => {
    const { page = 1, per_page = 10 } = params;
    try {
        const user = JSON.parse(localStorage.getItem("loggedUser"));
        const token = user?.token;
        const response = await axios.get(`${BASE_URL}/dashboard/coupons`, {
            params: { page, per_page },
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
                "Accept-Language": "ar",
            },
        });
        return response.data;
    } catch (error) {
        const message = error.response?.data?.message || "Failed load data";
        return rejectWithValue(message);
    }
});

// Add Coupon
export const addCoupon = createAsyncThunk("coupons/add", async (couponData, { rejectWithValue }) => {
    try {
        const user = JSON.parse(localStorage.getItem("loggedUser"));
        const token = user?.token;
        const response = await axios.post(`${BASE_URL}/dashboard/coupons`, couponData, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
                "Accept-Language": "ar",
            },
        });
        return { ...response.data, message: "تمت إضافة الكوبون بنجاح" };
    } catch (error) {
        const message = error.response?.data?.message || "فشل في إضافة الكوبون";
        return rejectWithValue(message);
    }
});

// Get Coupon Record
export const couponRecord = createAsyncThunk("coupons/couponRecord", async (id, { rejectWithValue }) => {
    try {
        const user = JSON.parse(localStorage.getItem("loggedUser"));
        const token = user?.token;
        const response = await axios.get(`${BASE_URL}/dashboard/coupons/${id}`, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
                "Accept-Language": "ar",
            },
        });
        return response.data;
    } catch (error) {
        const message = error.response?.data?.message || "فشل في تحميل بيانات الكوبون";
        return rejectWithValue(message);
    }
});

// Update Coupon
export const updateCoupon = createAsyncThunk("coupons/update", async ({ id, formData }, { rejectWithValue }) => {
    try {
        const user = JSON.parse(localStorage.getItem("loggedUser"));
        const token = user?.token;
        const response = await axios.put(`${BASE_URL}/dashboard/coupons/${id}`, formData, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
                "Accept-Language": "ar",
            },
        });
        return { ...response.data, message: "تم تحديث الكوبون بنجاح" };
    } catch (error) {
        const message = error.response?.data?.message || "فشل في تحديث الكوبون";
        return rejectWithValue(message);
    }
});

// Delete Coupon
export const deleteCoupon = createAsyncThunk("coupons/delete", async (id, { rejectWithValue }) => {
    try {
        const user = JSON.parse(localStorage.getItem("loggedUser"));
        const token = user?.token;
        const response = await axios.delete(`${BASE_URL}/dashboard/coupons/${id}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        const message = error.response?.data?.message || "فشل في حذف الكوبون";
        return rejectWithValue(message);
    }
});

const CouponsSlice = createSlice({
    name: "coupons",
    initialState: {
        coupons: { data: [] },
        record: null,
        meta: null,
        isLoading: false,
        error: null,
        success: null,
    },
    reducers: {
        clearState: (state) => {
            state.error = null;
            state.success = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchCoupons.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(fetchCoupons.fulfilled, (state, action) => {
                state.isLoading = false;
                state.meta = action.payload?.data?.pagination || null;
                state.coupons = {
                    data: action.payload?.data?.coupons_data || []
                };
            })
            .addCase(fetchCoupons.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload || "Failed to load data";
            })
            .addCase(addCoupon.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(addCoupon.fulfilled, (state, action) => {
                state.isLoading = false;
                state.success = action.payload.message;
            })
            .addCase(addCoupon.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload || "Failed to add data";
            })
            .addCase(couponRecord.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(couponRecord.fulfilled, (state, action) => {
                state.isLoading = false;
                state.record = action.payload.data;
            })
            .addCase(couponRecord.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.error?.message || "Failed to load record";
            })
            .addCase(updateCoupon.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(updateCoupon.fulfilled, (state, action) => {
                state.isLoading = false;
                state.success = action.payload.message;
            })
            .addCase(updateCoupon.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload?.message || action.payload || "Failed to update record";
            })
            .addCase(deleteCoupon.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(deleteCoupon.fulfilled, (state, action) => {
                state.isLoading = false;
                if (state.coupons?.data) {
                    state.coupons.data = state.coupons.data.filter((record) => record.id !== action.meta.arg);
                }
                state.success = action.payload?.message || "Deleted successfully";
            })
            .addCase(deleteCoupon.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload?.message || action.payload || action.error?.message || "Failed to delete coupon";
            });
    },
});

export const { clearState } = CouponsSlice.actions;
export default CouponsSlice.reducer;
